import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import ProcessExplorer from "./explorer/ProcessExplorer";
import styles from "./explorer/Explorer.module.scss"
import VariantExplorerImproved from "./explorer/VariantExplorerImproved";
import appContext from "../../../context/appContext";

const Explorer = props => {

  const history = useHistory();

  const context = useContext(appContext);

  const pathName = history.location.pathname;


  return (
    <div className={[styles.Explorer, context.handleApiStatusProcessExplorer() === "loading" && styles.loading].join(' ')}
         style={(history.location.pathname !== "/variant-explorer" && history.location.pathname !== "/process-compare" && history.location.pathname !== "/generate-bpmn-model") ? {width: 100} : null}>
      <div>
        {
          pathName !== "/process-explorer" ? (
            <React.Fragment>
              {
                ((history.location.pathname === "/process-compare" || history.location.search === "?view=side-by-side") && props.type !== "main-layer" && context?.handleLayerList()?.some(item => !item.type || item.type === "layer")) &&
                <VariantExplorerImproved
                  setVariantIndex={props.setVariantIndex}
                  variants={props.variants}
                  sliderColor={context?.handleLayerList()?.length && context?.handleLayerList()?.find(item => item.selected)?.color}
                  isSecondaryVariantExplorer={true}
                  isVariantExplorerLinked={history.location.pathname === "/process-compare" && context.handleIsVariantExplorerLinked()}
                />
              }
              {
                (history.location.pathname !== "/process-compare" || props.type === "processCompare" || props.type === "main-layer") &&
                <VariantExplorerImproved
                  setVariantIndex={props.setVariantIndex}
                  variants={props.variants}
                  isVariantExplorerLinked={history.location.pathname === "/process-compare" && context.handleIsVariantExplorerLinked()}
                />
              }
              {
                history.location.pathname === "/process-compare" && context.handleLayerList().length > 1 &&
                <button
                  className={[styles.linkButton, context.handleIsVariantExplorerLinked() && styles.active].join(" ")}
                  onClick={() => context.handleIsVariantExplorerLinked(!context.handleIsVariantExplorerLinked())}>
                  <i className={'d-flex align-items-center justify-content-between'}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.8">
                        <path
                          d="M10.51 12.5502L8.4699 14.5903C8.4699 14.5903 8.4699 14.5904 8.46985 14.5904C8.46985 14.5904 8.46985 14.5904 8.4698 14.5904C7.62617 15.4341 6.2534 15.4341 5.40968 14.5904C5.00095 14.1817 4.7759 13.6382 4.7759 13.0603C4.7759 12.4824 5.00095 11.9391 5.40954 11.5303C5.40959 11.5303 5.40963 11.5302 5.40968 11.5302L7.44975 9.49008C7.73139 9.20839 7.73139 8.75166 7.4497 8.47002C7.16806 8.18838 6.71133 8.18838 6.42964 8.47002L4.38958 10.5101C4.38943 10.5103 4.38929 10.5105 4.38915 10.5106C3.70829 11.1917 3.33331 12.0972 3.33331 13.0603C3.33331 14.0236 3.70843 14.9293 4.38963 15.6105C5.09274 16.3135 6.01624 16.6651 6.93979 16.6651C7.86334 16.6651 8.78688 16.3135 9.4899 15.6105V15.6104C9.48995 15.6104 9.48995 15.6104 9.48995 15.6104L11.53 13.5702C11.8117 13.2886 11.8117 12.8319 11.53 12.5502C11.2484 12.2686 10.7917 12.2686 10.51 12.5502Z"
                          fill="#0A195C"/>
                        <path
                          d="M16.6665 6.93971C16.6665 5.9764 16.2914 5.07074 15.6102 4.38955C14.204 2.98341 11.916 2.98346 10.5099 4.38955C10.5098 4.38964 10.5098 4.38969 10.5097 4.38979L8.46969 6.42976C8.188 6.7114 8.188 7.16817 8.46969 7.44981C8.61058 7.59071 8.79514 7.6611 8.97974 7.6611C9.1643 7.6611 9.34895 7.59066 9.48975 7.44981L11.5298 5.40985C11.5298 5.40975 11.5299 5.4097 11.53 5.4096C12.3736 4.56598 13.7464 4.56593 14.5901 5.4096C14.9988 5.81834 15.2239 6.36176 15.2239 6.93971C15.2239 7.51761 14.9989 8.06094 14.5903 8.46968C14.5902 8.46972 14.5902 8.46977 14.5901 8.46982L12.5501 10.5099C12.2684 10.7916 12.2684 11.2483 12.5501 11.53C12.691 11.6708 12.8756 11.7413 13.0601 11.7413C13.2447 11.7413 13.4293 11.6708 13.5702 11.53L15.6102 9.48988C15.6104 9.48973 15.6105 9.48954 15.6107 9.4894C16.2915 8.8083 16.6665 7.90279 16.6665 6.93971Z"
                          fill="#0A195C"/>
                        <path
                          d="M7.45004 12.5498C7.59088 12.6906 7.77549 12.7611 7.96004 12.7611C8.14465 12.7611 8.32925 12.6906 8.47009 12.5498L12.5503 8.46957C12.832 8.18793 12.832 7.7312 12.5503 7.44951C12.2687 7.16787 11.812 7.16787 11.5303 7.44951L7.45004 11.5297C7.16835 11.8114 7.16835 12.2682 7.45004 12.5498Z"
                          fill="#0A195C"/>
                      </g>
                    </svg>
                  </i>
                  <div className={'d-flex align-items-center justify-content-center'}>
                    Link
                  </div>
                </button>
              }
            </React.Fragment>
            ) :
            <ProcessExplorer
              { ...props }
            />
        }
      </div>
    </div>
  )
};

export default Explorer;
